import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { makeStyles } from "@material-ui/core/styles";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import React from "react";

const useStyles = makeStyles(
  {
    content: {
      alignItems: "center",
      display: "inline-flex",
      paddingBottom: "0 !important",
      paddingTop: "0 !important"
    },
    icon: {
      height: "20px",
      margintRight: 5
    },
    lineOne: {
      paddingBottom: 0,
      paddingTop: 0,
      textAlign: "center"
    },
    root: {
      "&:before": {
        backgroundColor: "#fdd0d6",
        bottom: -7,
        content: "' '",
        height: 20,
        position: "absolute",
        right: 40,
        transform: "rotate(45deg)",
        width: 20
      },
      backgroundColor: "#fdd0d6",
      border: "1px solid #fdd0d6",
      color: "#ec5e77",
      display: "inline-block",
      fontSize: "13px",
      marginBottom: 0,
      paddingBottom: 1,
      paddingTop: 5,
      position: "relative",
      width: "100%"
    }
  },
  { name: "StoreOrderSMACCard" }
);

export interface StoreOrderGCashTooltipProps {
  visible?: boolean;
}

const StoreOrderGCashTooltip: React.SFC<StoreOrderGCashTooltipProps> = props => {
  const classes = useStyles(props);

  // Added function to set toggle to GCash tool tip
  const { visible = false } = props;

  if (!visible) {
    return <></>;
  }

  return (
    <Card className={classes.root}>
      <CardContent className={classes.content}>
        <InfoOutlinedIcon className={classes.icon} />
        <div
          style={{
            paddingBottom: "0",
            zIndex: 1
          }}
        >
          <div className={classes.lineOne}>
            {" "}
            <span>
              Only single-tenant cancellations are applicable for automatic
              GCash refund. Otherwise, refunds will be processed manually.
            </span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default StoreOrderGCashTooltip;
